/* eslint-disable key-spacing */
/* eslint-disable no-trailing-spaces */
// 流向管理-->中英文
export const salseFlowLocale = {
    'zhCN': {
        // 数据导入
        importData: {
            viewDownloadTask: '查看下载进度',
            // 自动日志列表
            remark: '备注',
            saleQuantity: '销售数量',
            productMaterial: '产品/分型/物料',
            productName: '产品简称',
            monthOfFlow: '流向月份',
            saleDate: '销售日期',
            batchNo: '批号',
            notNull: '不能为空',
            tradeType: '销售类型',
            createTime: '创建日期',
            uploader: '上传人员',
            dataType: '数据类型',
            importTime: '导入时间',
            fileName: '原始文件',
            totalCount: '总数',
            wranningCount: '警告',
            differentCount: '错误',
            conflictCount: '冲突',
            wranningFileName: '警告文件',
            errorFileName: '错误文件',
            conflictFileName: '别名冲突文件',
            transitionMonth: '转换月份',
            transitionTotalCount: '转换总数',
            operationer: '操作人',
            operationTime: '操作时间',
            SAPTransition: 'SAP自动转换月数据',
            dailyFlow: '导入日流向模板下载',
            monthFlow: '导入月流向模板下载',
            dailyPurchase: '导入日采购模板下载',
            monthPurchase: '导入月采购模板下载',
            dailyInventory: '导入日库存模板下载',
            monthInventory: '导入月库存模板下载',
            sapData: '导入SAP日数据模板下载',
            dailyStatus: '导入经销商日数据提供情况模板下载',
            monthStatus: '导入经销商月数据提供情况模板下载',
            flowManagement: '流向管理',
            confirmationOfFlowDirectionData: '流向数据确认',
            traceabilityConfirmation: '可追溯商业流向确认',
            importType: '导入类型',
            originalReceiving: '收货方别名',
            targetHospital: '目标医院',
            standardReceivingParty: '收货方名称',
            traceabilityName: '可追溯流向名称',
            salesFlowDistributorName: '流向商业名称',
            salesFlowArea: '流向商业省份/城市',
            selectingTheReceivingParty: '选择收货方',
            monthlySAPSuccess: 'SAP月数据生成成功',
            tipsStart: '点击转换',
            tipsEnd: '的日数据为月数据',
            validateEnumTradeType: '销售类型不能为空',
            validateSalesFlowSource: '数据来源不能为空',
            productMaterialNotNull: '产品/分型/物料不能为空',
            saleQuantityNotNull: '销售数量必须大于0',
            distributorFlowOperationSave: '收货方类型和销售类型不匹配',
            operationFlow: '新增流向',
            editFlow: '编辑流向',
            whereDeleteSuccess: '是否删除',
            fileAllMessage: '上传附件不符合系统要求，请联系系统管理员',
            flowReversal: '流向冲销',
            fileIsTooLarge: '上传的附件过大，上传失败。',
            unknownError: '未知错误。',
            importFile: '导入文件',
            rightCount: '正确数',
            errorCount: '错误数',
            importAbnormalData: '错误数据地址',
            uploadTime: '上传时间',
            number: '只支持数字格式',
            maxLengtn: '最大长度不能超过16位',
            stillRunning: '有导入任务正在运行,请检查日志.',
            forceCompleteTask: '强制完成运行中的任务',
            viewLast10Log: '刷新状态',
            autoImportMonthlyData: '月数据导入',
            autoImportMonthlyDataSuccess: '开始导入月数据，请留意通知邮件。',
            salesFlowCycleError: '请选择记录月份',
            fileNameSuccess: '成功文件名称',
            fileCountSuccess: '成功文件数',
            endTime: '结束时间',
            searchStatus: '查询状态',
        },
        queryData: {
            sumQuantity: '库存数合计',
            cycleMonth: '周期月份',
            delete: '删除',
            add: '新增',
            all: '全部省份',
            confirm: '确认',
            allConfirm: '全部确认',
            whetherConfirm: '是否确认',
            whetherConfirmRemoveSelectedItems: '是否确认删除选中内容',
            whetherRelease: '是否发布流向数据',
            whetherReleaseRetry: '是否重试发布功能',
            whetherFreeze: '是否冻结当前流向数据',
            whetherAllConfirm: '是否全部确认',
            materialAllowOrder: '是否允许下单',
            startRecordRequired: '请选择需要确认的流向商业流向数据。',
            startAllRecordRequired: '没有需要确认的流向商业流向数据。',
            spanProvince: '跨省',
            importTypeName: '导入方式',
            remark: '备注',
            saleQuantity: '销售数量',
            saleQuantityLY: 'LY销售数量',
            salesAmount: '销售金额',
            salesAmountLY: 'LY销售金额',
            purchaseMonth: '采购日期(按月查询)',
            purchaseDate: '采购日期',
            purchaseQuantity: '采购数量',
            saleDate: '销售日期',
            startSalesFlowCycleMonth: '起始周期',
            endSalesFlowCycleMonth: '结束周期',
            salesFlowArea: '流向商业省份/城市',
            salesFlow: '流向商业名称',
            salesFlowPhCode: '流向商业PHCode',
            receiverArea: '收货方省份/城市',
            receiverPhCode: '收货方PHCode',
            receiverName: '收货方名称',
            receiver: '收货方名称',
            receiverNew: '收货方名称New',
            receiverSerchKey: '收货方名称关键字',
            receiverType: '收货方类型',
            receiverAnotherName: '收货方别名',
            receiverBeforeName: '收货方曾用名',
            tradeType: '销售类型',
            salesFlowIssueDateType: '数据发布时间',
            salesFlowSource: '数据来源',
            salesFlowAcquireType: '采集方式',
            importType: '导入方式',
            importTime: '导入日期',
            isSpanProvince: '跨省',
            productShortName: '产品简称',
            phCode: 'PHCode',
            batchNo: '批号',
            businessCompanyType: '商业公司类型',
            distributorBusinessCompanyType: '流向商业公司类型',
            upstreamDistributorBusinessCompanyType: '发货方公司类型',
            upstreamDistributorPHCode: '发货方PHCode',
            sequence: '序号',
            queryCode: '查询CODE',
            salesFlowCycleMonth: '记录月份',
            salesFlowCycleMonthLY: 'LY记录月份',
            salesFlowCityName: '流向商业城市',
            salesFlowDistrictName: '流向商业大区',
            salesFlowProvinceName: '流向商业省份',
            submitTime: '提交日期',
            productName: '产品简称',
            materialGroupName: '分型名称',
            materialName: '物料',
            materialCode: '物料号',
            expiryDate: '有效期',
            receiverProvinceName: '收货方省份',
            receiverCityName: '收货方城市',
            receiverCountyName: '收货方区县',
            saleType: '销售类型',
            actualTime: '实际日期',
            fileTypeName: '文件类型',
            returnTime: '返回时间',
            isReturn: '返回情况',
            searchProductType: '单产品/多分型',
            productMaterial: '产品/分型/物料',
            groupMaterial: '分型/物料',
            analepticFeedback: '反馈',
            receiverName_receiverAnotherName: '收货方名称',
            remainMonths: '剩余效期月数',
            monthOfFlow: '记录月份',
            notNull: '不能为空',
            pleaseSelectDataFirst: '请先选择数据',
            addPreparatorySalesFlowMonthly: '可追溯流向确认数据',
            attachmentName: '附件名',
            uploadTime: '上传时间',
            changeDefaultBatch: '修改',
            whetherChangeDefaultBatch: '是否修改',
            productCascaderRequired: '请选择分型/物料',
            batchNumberRequired: '请选择批号',
            notSelectMultipleProducts: '不能选择多个产品',
            whetherChangeDefaultBatchNumber: '权限不足,无法修改所选数据',
            analepticQueryModal: '兴奋剂流向反馈',
            analepticView: '查看兴奋剂反馈',
            deleteSuccess: '删除成功',
            originalRecipient: '收货方别名',
            preparatoryProvinceName: '可追溯商业省份',
            preparatoryArea: '可追溯商业省份/城市',
            preparatoryCityName: '可追溯商业城市',
            preparatoryName: '可追溯商业名称',
            preparatoryPHCode: '可追溯商业PHCode',
            dopingFeedbackLength: '反馈内容过长',
            salesReturnPercentSetUp: '退货率基线设置',
            salesReturnPercentSetUpIsNotNull: '退货率基线不能为空',
            percentSetUp: '百分比设定',
            salesReturnReason: '销退原因',
            chineseDescription: '中文描述',
            englishDescription: '英文描述',
            distributorProvinceName: '流向商业省份',
            distributorName: '流向商业名称',
            standardReceiver: '收货方名称',
            salesReturnOwnerNameCn: '主导人中文名',
            salesReturnOwnerNameEn: '主导人英文名',
            salesReturnOwnerIsNotNull: '销退主导人不能为空',
            salesReturnReasonIsNotNull: '销退原因不能为空',
            salesReturnReasonOverLength: '销退原因长度超过限制',
            descriptionCnOverLength: '销退中文描述长度超过限制',
            descriptionEnOverLength: '销退英文描述长度超过限制',
            salesReturnReasonManagement: '销退原因管理',
            salesReturnOwner: '主导人',
            ownerChineseNameIsNotNull: '主导人中文名不能为空',
            ownerChineseNameOverLength: '主导人中文名长度超过限制',
            ownerEnglishNameOverLength: '主导人英文名长度超过限制',
            salesReturnOwnerChineseName: '主导人中文',
            salesReturnOwnerEnglishName: '主导人英文',
            salesReturnOwnerManagement: '销退主导人管理',
            salesReturndescription: '备注',
            ownerName: '主导人',
            distributorProvinceCity: '流向商业省份/城市',
            distributorRegion: '流向商业团队',
            regionName: '团队',
            districtName: '大区',
            sales: '销量',
            purchaser: '购买方名称',
            invoiceCompany: '开票方',
            medicineGroup: '所属医药集团',
            tierType: '管理级别',
            salesFlowType: '数据来源',
            returnSales: '退货量',
            feadBackTime: '反馈日期',
            feadBackUser: '反馈人',
            terminalArea: '终端省份/城市',
            terminalName: '终端名称',
            terminalPHCode: '终端PHCode',
            terminalType: '终端类型',
            targerHospitalWarningType: '预警类型',
            onpassage: '在途',
            DDIInventory: 'DDI日库存',
            inventoryCount: '库存数',
            inventoryAmount: '库存金额',
            inventoryAmountTotal: '库存金额合计',
            isTargetHospital: '是否目标医院',
            isShowTargetHospital: '是否展示目标医院',
            totalAmount: '合计',
            targetHospitalListYes: '展示目标医院',
            targetHospitalListNo: '不展示目标医院',
            isAssessmentPrice: '列表中金额按照物料的考核价进行计算，若考核价未维护，则按0进行计算。',
            receivingArea: '收货方区县',
            totalOfAmount: '合计(金额)',
            totalSales: '销量合计',
            totalPurchase: '采购合计',
            totalPurchaseQuantity: '采购数量合计',
            whetherTraceable: '是否发布可追溯流向数据',
            totalOndAmount: '金额合计',
            distributorMdMCode: '发货方MDMCode',
            receiverMdMCode: '收货方MDMCode',
            receiverMDMName: '收货方MDM名称',
            mdmName: 'MDM名称',
            newMdMCode: 'MDMCodeNew',
            newMdMName: 'MDM名称New',
            phcodeNew: 'PHCodeNew',
            isSplitReceiver: '是否拆分',
            prescriptionSource: '处方来源',
            partner: '合作伙伴',
            businessCategory: '业务分类',
            deliveryAddress: '送货地址',
            customerID: '客户ID号',
            deliveryReceiverName: '收货方名称New',
            deliveryReceiverType: '收货方New类型',
            splitDate: '拆分日期',
            businessStatus: '经营状态',
            whetherUpdatePHCodeNew: '是否更新PHCodeNew？',
            tmsMonthly: '报表月份',
            generateTmsReport: '生成报表',
            generateTmsReportDateRequired: '请选择生成的月份',
            generateTMSSuccess: '生成成功',
            salesFlowMDMCode: '流向商业MDMCode',
            deliveryReceiverProvince: '收货方New省份',
            orginDistributorProvince: '货源商业省份',
            orginDistributorName: '货源商业名称',
            orginDistributorPHCode: '货源商业PHCode',
            isOrgin: '是否追溯到货源',
            isCreatedSalesFlow: '是否已生成流向',
            salesFlowQueryCode: '流向查询Code',
            transferQueryCode: '调拨查询Code',
            orginQueryCode: '源采购查询Code',
            calculateReport: '生成报表',
            createSalesFlow: '生成月流向',
            termianlName: '扣减终端',
            terminalPHCode: '扣减终端PHCode',
            createSalesFlowTime: '生成流向时间',
            amount: '金额',
            whetherCalculateReport: '是否生成三方购进报表？',
            calculateSuccessful: '生成成功！',
            whetherCreateSalesFlowTime: '是否将未生成流向的数据生成月流向？',
            createThirdReport: '生成三方购进数据',
            whetherCreateThirdReport: '当前数据已生成过三方购进数据，是否再次生成？',
            isCreatedThirdReport: '是否三方购进处理',
            whetherCreateThirdReportDefault: '是否将此数据按未追溯到货源生成三方购进数据？',
            baselineMaintenance: '预警基线维护'
        },
        // 数据删除
        deleteData: {
            sellerArea: '流向商业省份/城市',
            sellerProvince: '流向商业省份',
            sellerCity: '流向商业城市',
            seller: '流向商业',
            sellerPHCode: '流向商业PHCode',
            sellerLevel: '流向商业级别',
            phCode: 'PHCode',
            fileType: '文件类型',
            returnStatus: '返回情况',
            returnTime: '返回日期',
            actualDate: '实际日期',
            delAll: '全部删除',
            recordMonth: '记录月份',
            receiverArea: '收货方省份/城市',
            receiverProvince: '收货方省份',
            receiverName: '收货方名称',
            receiver: '收货方名称',
            receiverPhCode: '收货方PHCode',
            receiverType: '收货方类型',
            searchProduct: '单产品/多产品',
            searchProductType: '单产品/多分型',
            batchNo: '批号',
            submitTime: '提交时间',
            searchCode: '查询Code',
            productName: '产品简称',
            materiel: '物料',
            packingUnit: '包装单位',
            purchaseDate: '采购日期',
            purchaseQuantity: '采购数量',
            fatherProvince: '上游省份',
            fatherName: '上游名称',
            inventoryDate: '库存日期',
            type: '分型名称',
            expiryDate: '有效期',
            quantity: '数量',
            searchByMonth: '按月查询',
            searchByDay: '按日查询',
            salesFlowArea: '流向商业省份/城市',
            salesFlowProvince: '流向商业省份',
            salesFlowCity: '流向商业城市',
            salesFlowPhCode: '流向商业PHCode',
            salesFlow: '流向商业名称',
            salesFlowName: '流向商业名称',
            salesFlowChannelLevel: '流向商业渠道级别',
            saleType: '销售类型',
            saleQuantity: '销售数量',
            remark: '备注',
            invoicerArea: '发货方省份/城市',
            invoicerProvince: '发货方省份',
            invoicerName: '发货方名称',
            businessCompanyType: '商业公司类型',
            dataAffordSituation: '数据提供情况',
            delAllDialog: '确定要删除吗？'
        },
        // 流向核查
        deficiencyInspect: {
            whetherToConfirmFeedback: '反馈后不可更改，是否确认反馈！',
            salesFlowCycleID: '记录月份',
            distributor: '流向商业',
            deficiencyType: '差异类型',
            tradeType: '销售类型',
            responsibilityer: '负责人',
            distributorProvince: '流向商业省份',
            receiver: '收货方',
            receiverPHCode: '收货方PHCODE',
            productName: '产品简称',
            materialGroup: '分型名称',
            material: '物料',
            batchNumber: '批号',
            validityDate: '有效期',
            saleDate: '销售日期',
            quantity: '数量',
            remark: '备注',
            submitTime: '更新时间',
            shipper: '发货方',
            shipperRegion: '发货方团队',
            shipperDistrict: '发货方大区',
            receiverDistrict: '收货方大区',
            shipperProvince: '发货方省份',
            shipperCity: '发货方城市',
            shipperProvinceAndCity: '发货方省份/城市',
            shipperPHCode: '发货方PHCode',
            salesDate: '销售月份',
            isHandled: '是否处理',
            isProvideSale: '是否提供流向',
            shipperCompanyName: '登记发货公司',
            receiverEmployeeName: '收货方负责人',
            handleUpdate: '外勤处理',
            handleCheck: '查看',
            salesFlowAbnormal: '渠道反馈',
            salesFlowDetailed: '流向明细',
            feedbackReason: '反馈原因',
            feedbackReasonOne: '渠道归拢中，暂不调整',
            feedbackReasonTow: '按照实际发货上游变更渠道',
            hasFeedBack: '已反馈',
            suspectAllocation: '疑似调拨',
            addProductChannel: '新增渠道',
            feadBack: '反馈',
            isFeadBack: '反馈完成',
            salesFlowCategory: '数据来源',
            roleTag: '角色标签',
            feadBackUser: '反馈人',
            feadBackTime: '反馈日期',
            createTime: '生成时间',
            salesFlowDaily: '日流向',
            salesFlowMonthly: '月流向',
            feedbackReasonRequired: '反馈原因必填',
            existPending: '存在待审批/待确认的申请单',
            existPendingeffect: '存在待生效的申请单',
            existPendingeffectConfirm: '存在待生效的申请单,是否撤回重新申请',
            feedbackSuccess: '反馈成功',
            enumSalesFlowCategoryDesc: '数据来源',
            isHandledDesc: '反馈完成',
            isChannelAbnormal: '是否需要反馈',
            newUpstreamName: '新上游',
            feadBackUserName: '反馈人',
            changeChannel: '变更渠道',
            existenceIncompleteApproval: '存在未完成审批得单据，无法变更渠道',
            existingPendingApplicationForm: '存在待生效申请单，是否撤销后重新申请？',
            confirmFeedBack: '反馈后不可更改，是否确认反馈？',
            actualShipmentUpstream: '实际发货上游',
            registerUpstream: '登记上游',
            theNumberShipments: '发货数量',
            warningType: '预警类型',
            distributorEmployeeName: '发货方负责人',
            targetHospital: '目标医院',
            notTargetHospital: '非目标医院',
            redWarning: '红色预警',
            yellowWarning: '黄色预警',
            terminalName: '终端名称',
            terminalNameNew: '终端名称New',
            terminalRegion: '团队',
            terminalProvinceName: '终端省份',
            terminalPHCode: '终端PHCode',
            terminalPHCodeNew: '终端PHCodeNew',
            targetHospatilType: '收货方类型',
            productReferred: '产品简称',
            lastOneMonthQuantity: '前1月销量',
            lastTweMonthQuantity: '前2月销量',
            lastThreeMonthQuantity: '前3月销量',
            lastFourMonthQuantity: '前4月销量',
            lastFiveMonthQuantity: '前5月销量',
            lastSixMonthQuantity: '前6月销量',
            currentMonthQuantity: '当月销量',
            lastSixMonthAVGQuantity: '前6个月平均销量',
            isTargetHospital: '是否目标医院',
            allTargetHospitalData: '全部数据',
            warningTargetHospitalData: '预警数据',
            whetherRememberReason: '是否需要记录反馈原因并应用于未来月份的反馈？' // '是否记住该反馈操作？'
        },
        // 日数据预警
        dailySalesflowDefference: {
            AvgCount: '当日预估条数',
            avgSalesQuantity: '当日预估销量',
            mTDCountYesterday: '昨日MTD条数',
            mTDQuantityYesterday: '昨日MTD销量',
            mTDCountToday: '今日MTD条数',
            mTDQuantityToday: '今日MTD销量',
            mTDCountDifference: 'MTD条数差异',
            mTDQuantityDifference: 'MTD销量差异',
            mTDCountRateOfIncrease: 'MTD条数增幅',
            mTDQuantityRateOfIncrease: 'MTD销量增幅',
            isUpdateDaliyData: '是否更新日数据统计数据',
            reportCreateTime: '报表生成日期',
            reportUpdateTime: '数据更新时间',
            baseLine: '基线',
            baselineBeEmpty: '基线不能为空',
            baselineLength: '基线超过最大值',
            warningType: '预警类型',
            maxSalesDate: '最大销售日期',
            lastMonthSalesCount: '上月N天有销量',
            currentMonthSalesCount: '当月N天有销量'

        },
        //DTP数据管理
        dtpDataManagement: {
            dtpCategory1: '业务字段1',
            dtpCategory2: '业务字段2',
            dtpCategory3: '业务字段3',
            dtpArea: '专业药房省份/城市',
            dtpName: '专业药房名称',
            dtpCFS: '专业药房负责人',
            dtpPHCode: '专业药房PHCode',
            dtpMDMCode: '专业药房MDMCode',
            dtpType: '专业药房类型',
            packagingUnit: '数量单位',
            dtpProvince: '专业药房省份',
            dtpTemplate: '导入DTP数据模板'
        }
    },
    'enUS': {
        // 数据导入
        importData: {
            viewDownloadTask: 'View Download',
            remark: 'Remark',
            saleQuantity: 'Quantity',
            productMaterial: 'Product/Material Group/Material',
            productName: 'Product Referred',
            monthOfFlow: 'Month',
            saleDate: 'Sale Date',
            batchNo: 'Batch Number',
            notNull: ' Required',
            tradeType: 'Trade Type',
            createTime: 'CreateTime',
            uploader: 'Uploader',
            dataType: 'Data Type',
            importTime: 'Import Time',
            fileName: 'File Name',
            totalCount: 'Total',
            wranningCount: 'Wranning',
            differentCount: 'Error',
            conflictCount: 'Conflict',
            wranningFileName: 'Wranning Data',
            errorFileName: 'Error Data',
            conflictFileName: 'Conflict Data',
            transitionMonth: 'Month',
            transitionTotalCount: 'Total',
            operationer: 'Operator',
            operationTime: 'Operation Time',
            SAPTransition: 'Generate',
            dailyFlow: 'Daily SalesFlow',
            monthFlow: 'Monthly SalesFlow',
            dailyPurchase: 'Daily Purchase',
            monthPurchase: 'Monthly Purchase',
            dailyInventory: 'Daily Inventory',
            monthInventory: 'Monthly Inventory',
            sapData: 'SAP SalesFlow',
            dailyStatus: 'Daily Status',
            monthStatus: 'Monthly Status',
            flowManagement: 'Sales Flow',
            confirmationOfFlowDirectionData: 'Confirm',
            traceabilityConfirmation: 'Preparatory Sales Flow',
            importType: 'Import Type',
            originalReceiving: 'Receiver Alias',
            targetHospital: 'Target hospital',
            standardReceivingParty: 'Receiver Name',
            traceabilityName: 'Preparatory Distributor Name',
            salesFlowDistributorName: 'Distributor Name',
            salesFlowArea: 'Distributor Province/City',
            selectingTheReceivingParty: 'Choose Receiver',
            monthlySAPSuccess: 'Success',
            tipsStart: 'Generate',
            tipsEnd: 'SAP Monthly SalesFlow',
            validateEnumTradeType: 'TradeType is required',
            validateSalesFlowSource: 'SalesFlow source is required',
            productMaterialNotNull: 'Required',
            saleQuantityNotNull: 'Sales quantity must be greater than 0.',
            distributorFlowOperationSave: 'The type of receiver and the type of sale do not match.',
            operationFlow: 'Add SalesFlow',
            editFlow: 'Edit SalesFlow',
            whereDeleteSuccess: 'Are you sure you want to delete it?',
            fileAllMessage: 'Uploading attachments does not meet the system requirements, please contact the administrator.',
            flowReversal: 'Flow reversal',
            fileIsTooLarge: 'The attachment you uploaded is too large and the upload failed.',
            unknownError: 'Unknown error.',
            deliveryAddress: 'DeliveryAddress',
            prescriptionSource: 'PrescriptionSource',
            partner: 'Partner',
            importFile: 'Import File',
            rightCount: 'Right Count',
            errorCount: 'Error Count',
            importAbnormalData: 'Error Data',
            uploadTime: 'Upload Time',
            customerID: 'Customer ID',
            number: 'mast be Number',
            maxLengtn: 'Maximum length cannot exceed 16 bits',
            stillRunning: 'This is running task, please check log.',
            forceCompleteTask: 'Force complete tasks',
            viewLast10Log: 'View lastest salesflow 10 log',
            autoImportMonthlyData: 'Import Monthly Data',
            autoImportMonthlyDataSuccess: 'Starting to import monthly data, please pay attention to the notification email.',
            salesFlowCycleError: 'Please select the month for recording.',
            fileNameSuccess: 'SuccessfulFileName',
            fileCountSuccess: 'SuccessfulFileCount',
            endTime: 'EndTime',
            searchStatus: 'Search Status',
        },
        queryData: {
            sumQuantity: 'Total inventory',
            cycleMonth: 'Month',
            delete: 'Delete',
            add: 'Add',
            all: 'All Province',
            confirm: 'Confirm',
            allConfirm: 'All Confirm',
            whetherConfirm: 'Are you sure you want to confirm it?',
            whetherConfirmRemoveSelectedItems: 'Are you sure you want to confirm it?',
            whetherRelease: 'Are you sure you want to release it?',
            whetherReleaseRetry: 'Are you sure you want to retry release it?',
            whetherFreeze: 'Are you sure you want to freeze it?',
            whetherAllConfirm: 'Are you sure you want to confirm it?',
            materialAllowOrder: 'Whether to allow orders',
            startRecordRequired: 'Please select the data you need to confirm.',
            startAllRecordRequired: 'There is no data to confirm.',
            spanProvince: 'Cross Province',
            importTypeName: 'Import Type',
            remark: 'Remark',
            purchaseMonth: 'Purchase Date',
            saleQuantityLY: 'LY sales quantity',
            salesAmount: 'Sales Amount',
            salesAmountLY: 'LY sales amount',
            purchaseDate: 'Purchase Date',
            saleDate: 'Sale Date',
            startSalesFlowCycleMonth: 'Start Cycle',
            endSalesFlowCycleMonth: 'End Cycle',
            salesFlowCycleMonth: 'Record month',
            salesFlowCycleMonthLY: 'LY record month',
            purchaseQuantity: 'Quantity',
            salesFlowArea: 'Distributor Province/City',
            saleQuantity: 'Quantity',
            salesFlow: 'Distributor Name',
            receiverArea: 'Receiver Province/City',
            receiverName: 'Receiver Name',
            receiver: 'Receiver',
            receiverNew: 'ReceiverNew',
            receiverSerchKey: 'Receiver Name Serch Key',
            receiverAnotherName: 'Receiver Alias',
            receiverBeforeName: 'Receiver Former Name',
            receiverType: 'Receiver Type',
            receiverPhCode: 'Receiver PHCode',
            salesFlowPhCode: 'Distributor PHCode',
            tradeType: 'Trade Type',
            salesFlowIssueDateType: 'Data Issue Date',
            salesFlowSource: 'Data Source',
            salesFlowAcquireType: 'Acquire Type',
            importType: 'Import Type',
            importTime: 'ImportTime',
            isSpanProvince: 'Cross Province',
            productShortName: 'Product Referred',
            batchNo: 'Batch Number',
            businessCompanyType: 'Distributor Type',
            sequence: 'No',
            queryCode: 'Query Code',
            salesFlowProvinceName: 'Province',
            salesFlowCityName: 'City',
            salesFlowDistrictName: 'Region',
            actualTime: 'ActualTime',
            fileTypeName: 'FileType',
            returnTime: 'ReturnTime',
            isReturn: 'Return Status',
            phCode: 'PHCode',
            submitTime: 'Submit Time',
            productName: 'Product Referred',
            materialGroupName: 'Material Group',
            materialName: 'Material',
            materialCode: 'Material Code',
            expiryDate: 'Expiry Date',
            receiverProvinceName: 'Province',
            receiverCityName: 'City',
            receiverCountyName: 'County',
            saleType: 'Trade Type',
            searchProductType: 'Material Group',
            productMaterial: 'Product/Material Group/Material',
            groupMaterial: 'Material Group/Material',
            analepticFeedback: 'Reply',
            receiverName_receiverAnotherName: 'Receiver Name',
            remainMonths: 'Remaining Months',
            monthOfFlow: 'Month',
            notNull: ' Required',
            pleaseSelectDataFirst: 'Please choose the data to be processed.',
            addPreparatorySalesFlowMonthly: 'Confirm Preparatory SalesFlow',
            attachmentName: 'Attachment Name',
            uploadTime: 'Upload Time',
            changeDefaultBatch: 'Edit',
            whetherChangeDefaultBatch: 'Are you sure you want to modify it?',
            productCascaderRequired: 'Required',
            batchNumberRequired: 'Required',
            notSelectMultipleProducts: 'Multiple products cannot be selected.',
            whetherChangeDefaultBatchNumber: 'You have enough permissions to edit',
            analepticQueryModal: 'Reply',
            analepticView: 'View',
            deleteSuccess: 'Success',
            originalRecipient: 'Shipper alias',
            preparatoryProvinceName: 'Preparatory Province Name',
            preparatoryArea: 'Business province/city traceability',
            preparatoryCityName: 'Business cities are traceable',
            preparatoryName: 'Preparatory Name',
            preparatoryPHCode: 'Preparatory PHCode',
            dopingFeedbackLength: 'Feedback Too Long',
            salesReturnPercentSetUp: 'Sales Return Rate Line',
            salesReturnPercentSetUpIsNotNull: 'Sales Return Rate Line can not be  empty',
            percentSetUp: 'Percent Setting',
            salesReturnReason: 'Sales Return Reason',
            chineseDescription: 'Chinese Description',
            englishDescription: 'English Description',
            distributorProvinceName: 'Distributor Province',
            distributorName: 'Distributor Name',
            standardReceiver: 'Receiver Name',
            salesReturnOwnerNameCn: 'Owner Chinese Name',
            salesReturnOwnerNameEn: 'Owner English Name',
            salesReturnOwnerIsNotNull: 'Owner can not be empty',
            salesReturnReasonIsNotNull: 'Reason can not be empty',
            salesReturnReasonOverLength: 'Reason is too long',
            descriptionCnOverLength: 'Sales return chinese description is too long',
            descriptionEnOverLength: 'Sales return english description is too long',
            salesReturnOwner: 'SalesReturnOwner',
            salesReturnReasonManagement: 'SalesReturnReasonManagement',
            ownerChineseNameIsNotNull: 'Owner chinese can not be empty',
            ownerChineseNameOverLength: 'Owner chinese is too long',
            ownerEnglishNameOverLength: 'Owner english is too long',
            salesReturnOwnerChineseName: 'Owner Chinese Name',
            salesReturnOwnerEnglishName: 'Owner English Name',
            salesReturnOwnerManagement: 'SalesReturnOwnerManagement',
            salesReturndescription: 'Remark',
            ownerName: 'OWNER',
            distributorProvinceCity: 'Province/City',
            distributorRegion: 'Team',
            regionName: 'Team',
            districtName: 'Region',
            sales: 'Sales',
            purchaser: 'Purchaser',
            invoiceCompany: 'Bill Company',
            medicineGroup: 'Medicine Group',
            tierType: 'Management level',
            salesFlowType: 'Data Sources',
            returnSales: 'Return amount',
            feadBackTime: 'FeadBack Time',
            feadBackUser: 'FeadBack User',
            terminalArea: 'Terminal Area',
            terminalName: 'Terminal Name',
            terminalPHCode: 'Terminal PHCode',
            terminalType: 'Terminal Type',
            targerHospitalWarningType: 'Warning Type',
            onpassage: 'on the way',
            DDIInventory: 'DDI Daily stock',
            inventoryCount: 'Inventory',
            inventoryAmount: 'Amount',
            inventoryAmountTotal: 'TotalAmount',
            isTargetHospital: 'Is TargetHospital',
            totalAmount: 'Total',
            targetHospitalListYes: 'Display target hospital',
            targetHospitalListNo: 'Do not show the target hospital',
            isAssessmentPrice: 'In the list the amount is calculated according to the assessed price of the material. If the assessed price is not maintained, it is calculated as 0.',
            receivingArea: 'Receiving area',
            totalOfAmount: 'total(Amount)',
            totalSales: 'Total sales',
            totalPurchase: 'Total Purchase',
            totalPurchaseQuantity: 'Total Purchase',
            totalOndAmount: 'Total amount',
            whetherTraceable: 'Whether to publish traceable flow data',
            isShowTargetHospital: 'Whether to show the target hospital',
            distributorMdMCode: 'Distributor MDMCode',
            receiverMdMCode: 'Receiver MDMCode',
            receiverMDMName: 'Receiver MDMName',
            mdmName: 'MDMName',
            newMdMCode: 'MDMCodeNew',
            newMdMName: 'MDMNameNew',
            phcodeNew: 'PHCodeNew',
            isSplitReceiver: 'Is Split Receiver',
            prescriptionSource: 'Prescription Source',
            partner: 'Partner',
            businessCategory: 'Category',
            deliveryAddress: 'DeliveryAddress',
            customerID: 'Customer ID',
            deliveryReceiverName: 'ReceiverNameNew',
            deliveryReceiverType: 'ReceiverTypeNew',
            splitDate: 'Split Date',
            businessStatus: 'Business Status',
            whetherUpdatePHCodeNew: 'Need to update PHCodeNew？',
            tmsMonthly: 'Monthly',
            generateTmsReport: 'Generate TMS Report',
            generateTmsReportDateRequired: 'Required',
            generateTMSSuccess: 'Generate Success',
            upstreamDistributorBusinessCompanyType: 'Shipper Company Type',
            upstreamDistributorPHCode: 'Shipper PHCode',
            distributorBusinessCompanyType: 'Distributor Business Company Type',
            salesFlowMDMCode: 'DistributorMDMCode',
            deliveryReceiverProvince: 'DeliveryReceiverProvince',
            orginDistributorProvince: 'OrginDistributorProvince',
            orginDistributorName: 'OrginDistributorName',
            orginDistributorPHCode: 'OrginDistributorPHCode',
            isOrgin: 'IsOrgin',
            isCreatedSalesFlow: 'IsCreatedSalesFlow',
            salesFlowQueryCode: 'SalesFlowQueryCode',
            transferQueryCode: 'TransferQueryCode',
            orginQueryCode: 'OrginQueryCode',
            calculateReport: 'CalculateReport',
            createSalesFlow: 'CreateSalesFlow',
            termianlName: 'TermianlName',
            terminalPHCode: 'TerminalPHCode',
            createSalesFlowTime: 'CreateSalesFlowTime',
            amount: 'Amount',
            whetherCalculateReport: 'Whether calculate report?',
            calculateSuccessful: 'Successful',
            whetherCreateSalesFlowTime: 'Whether create sales flow?',
            createThirdReport: 'CreateThirdReport',
            whetherCreateThirdReport: 'Whether calculate report?',
            isCreatedThirdReport: 'Whether calculate report',
            whetherCreateThirdReportDefault: 'Whether calculate report?',
            baselineMaintenance: 'Baseline Maintenance'
        },
        // 数据删除
        deleteData: {
            sellerArea: 'Distributor Province/City',
            sellerProvince: 'Distributor Province',
            sellerCity: 'Distributor City',
            seller: 'Distributor',
            sellerPHCode: 'Distributor PHCode',
            sellerLevel: 'Tier',
            phCode: 'PHCode',
            fileType: 'Data Type',
            returnStatus: 'Return Status',
            returnTime: 'Return Time',
            actualDate: 'Actual Date',
            delAll: 'Delete All',
            recordMonth: 'Month',
            receiverArea: 'Receiver Province/City',
            receiverProvince: 'Receiver Province',
            receiverName: 'Receiver Name',
            receiver: 'Receiver',
            receiverPhCode: 'Receiver PHCode',
            receiverType: 'Receiver Type',
            searchProduct: 'Product',
            searchProductType: 'Material Group',
            batchNo: 'Batch Number',
            submitTime: 'Submit Time',
            searchCode: 'Query Code',
            productName: 'Product Referred',
            materiel: 'Material',
            packingUnit: 'Package',
            purchaseDate: 'Purchase Date',
            purchaseQuantity: 'Quantity',
            fatherProvince: 'Upstream Province',
            fatherName: 'Upstream',
            inventoryDate: 'Inventory Date',
            type: 'Material Group',
            expiryDate: 'Expiry Date',
            quantity: 'Quantity',
            searchByMonth: 'By Monthly',
            searchByDay: 'By Daily',
            salesFlowArea: 'Distributor Province/City',
            salesFlowProvince: 'Distributor Province',
            salesFlowCity: 'Distributor City',
            salesFlowPhCode: ' Distributor PHCode',
            salesFlow: 'Distributor Name',
            salesFlowName: 'Distributor Name',
            salesFlowChannelLevel: 'Tier',
            saleType: 'Trade Type',
            saleQuantity: 'Quantity',
            remark: 'Remark',
            invoicerArea: 'Shipper Area',
            invoicerProvince: 'Shipper Province',
            invoicerName: 'Shipper',
            businessCompanyType: 'Shipper Type',
            dataAffordSituation: 'Data Status',
            delAllDialog: 'Are you sure you want to delete it?'
        },
        // 流向核查
        deficiencyInspect: {
            whetherToConfirmFeedback: 'Feedback can not be changed, whether to confirm the feedback!',
            salesFlowCycleID: 'Month',
            distributor: 'Distributor',
            deficiencyType: 'Deficiency Type',
            tradeType: 'Trade Type',
            responsibilityer: 'Representative',
            distributorProvince: 'Distributor Province',
            receiver: 'Receiver',
            receiverPHCode: 'Receiver PHCode',
            productName: 'Product Referred',
            materialGroup: 'Material Group',
            material: 'Material',
            batchNumber: 'Batch Number',
            validityDate: 'Expiry Date',
            saleDate: 'Sale Date',
            quantity: 'Quantity',
            remark: 'Remark',
            submitTime: 'Submit Time',
            shipper: 'Distributor',
            shipperRegion: 'Distributor Team',
            shipperDistrict: 'Distributor Region',
            receiverDistrict: 'Receiver Region',
            shipperProvince: 'Distributor Province',
            shipperCity: 'Distributor City',
            shipperProvinceAndCity: 'Distributor Province/City',
            shipperPHCode: 'Distributor PHCode',
            salesDate: 'Month',
            isHandled: 'Is Handled',
            isProvideSale: 'Provide SalesFlow',
            shipperCompanyName: 'Upstream',
            receiverEmployeeName: 'Receiver Employee',
            handleUpdate: 'Reply',
            handleCheck: 'View',
            salesFlowAbnormal: 'Channel Feedback',
            salesFlowDetailed: 'SalesFlow Detail',
            feedbackReason: 'Feedback reason',
            feedbackReasonOne: 'Channels are being rolled up, not adjusted yet',
            feedbackReasonTow: 'According to the actual shipment upstream change channel',
            hasFeedBack: 'Has Feedback',
            suspectAllocation: 'Suspect Allocation',
            addProductChannel: 'Add Product Channel',
            feadBack: 'Fead Back',
            isFeadBack: 'Is FeedBack',
            salesFlowCategory: 'Data Sources',
            roleTag: 'Role Tag',
            feadBackUser: 'FeedBack User',
            feadBackTime: 'FeedBack Time',
            createTime: 'Create Time',
            salesFlowDaily: 'SalesFlow Daily',
            salesFlowMonthly: 'SalesFlow Monthly',
            feedbackReasonRequired: 'Feedback Reason Required',
            existPending: 'There are pending approval/to be confirmed application forms',
            existPendingeffect: 'There is an application form to be valid',
            existPendingeffectConfirm: 'There is an application form to be valid, whether to withdraw the re-application',
            feedbackSuccess: 'Feedback Success',
            enumSalesFlowCategoryDesc: 'Data sources',
            isHandledDesc: 'Feedback completed',
            isChannelAbnormal: 'Need feedback',
            newUpstreamName: 'New upstream',
            feadBackUserName: 'Feedback person',
            changeChannel: 'Change channel',
            existenceIncompleteApproval: 'Documents that have not been completed for examination and approval cannot be altered',
            existingPendingApplicationForm: 'If there is an application form to be effective, will it be revoked and reapplied?',
            confirmFeedBack: 'Cannot be changed after feedback, is the feedback confirmed?',
            actualShipmentUpstream: 'Actual shipment upstream',
            registerUpstream: 'Register upstream',
            theNumberShipments: 'The number of shipments',
            warningType: 'Warning Type',
            distributorEmployeeName: 'Distributor Employee',
            targetHospital: 'Target Hospital',
            notTargetHospital: 'Not Target Hospital',
            redWarning: 'Red Warning',
            yellowWarning: 'Yellow Warning',
            terminalName: 'Terminal Name',
            terminalRegion: 'Team',
            terminalProvinceName: 'Province',
            terminalPHCode: 'PHCode',
            targetHospatilType: 'Receiver Type',
            productReferred: 'Referred',
            lastOneMonthQuantity: 'Last One Month Sales',
            lastTweMonthQuantity: 'Last Twe Month Sales',
            lastThreeMonthQuantity: 'Last Three Month Sales',
            lastFourMonthQuantity: 'Last Four Month Sales',
            lastFiveMonthQuantity: 'Last Five Month Sales',
            lastSixMonthQuantity: 'Last Six Month Sales',
            currentMonthQuantity: 'Current Month Sales',
            lastSixMonthAVGQuantity: 'Average Sales',
            isTargetHospital: 'Is Target Hospital',
            allTargetHospitalData: 'All Data',
            warningTargetHospitalData: 'Warning Data',
            whetherRememberReason: 'Is it necessary to record the reason for the feedback and apply it to the feedback in future months?'
        },
        // 日数据预警
        dailySalesflowDefference: {
            AvgCount: 'Estimated number of entries of the day',
            avgSalesQuantity: 'Estimated sales volume of the day',
            mTDCountYesterday: 'Number of MTD yesterday',
            mTDQuantityYesterday: 'MTD sales yesterday',
            mTDCountToday: 'Number of MTDS today',
            mTDQuantityToday: 'MTD sales today',
            mTDCountDifference: 'MTD number difference',
            mTDQuantityDifference: 'MTD sales variance',
            mTDCountRateOfIncrease: 'Increase in MTD number',
            mTDQuantityRateOfIncrease: 'MTD sales growth',
            isUpdateDaliyData: 'Update daily statistics',
            baseLine: 'Baseline',
            baselineBeEmpty: 'Required',
            baselineLength: 'Maximum support for 9 digit integer',
            warningType: 'WarningType',
            maxSalesDate: 'MaxSalesDate',
            lastMonthSalesCount: 'LastMonthSalesCount',
            currentMonthSalesCount: 'CurrentMonthSalesCount'
        },
        //DTP数据管理
        dtpDataManagement: {
            dtpCategory1: 'Bizfield1',
            dtpCategory2: 'Bizfield2',
            dtpCategory3: 'Bizfield3',
            dtpArea: 'Spe_PharmacyProvince/City',
            dtpName: 'Spe_Pharmacyname',
            dtpCFS: 'Spe_PharmacyCFS',
            dtpPHCode: 'Spe_PharmacyPHCode',
            dtpMDMCode: 'Spe_PharmacyMDMCode',
            dtpType: 'Spe_PharmacyType',
            packagingUnit: 'Unit',
            dtpProvince: 'Spe_PharmacyProvince',
            dtpTemplate: 'DTP Data Import Template'
        }
    }
}
export default salseFlowLocale



// WEBPACK FOOTER //
// ./src/locale/modules/salseFlowLocale.js